// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from "firebase/app";

// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import "firebase/analytics";

// Add the Firebase products that you want to use
import "firebase/auth";
import "firebase/firestore";
import "firebase/database";
import "firebase/analytics";
import "firebase/performance";

let firebaseConfig;
let rtDbRootNode;
if (process.env.NODE_ENV === "production") {
  console.log('IN PROD');
  rtDbRootNode = 'games';
  firebaseConfig = {
    apiKey: "AIzaSyDhQUkqcJWyLrGafTCnrJTj4N-aq5ifqHo",
    authDomain: "acquire-9b72d.firebaseapp.com",
    databaseURL: "https://acquire-9b72d.firebaseio.com",
    projectId: "acquire-9b72d",
    storageBucket: "acquire-9b72d.appspot.com",
    messagingSenderId: "435322013360",
    appId: "1:435322013360:web:fe8266c091398696471d75",
    measurementId: "G-MS8ZPTP85P"
  };
} else {
  console.log('IN DEV');
  rtDbRootNode = 'localDevGames';
  firebaseConfig = {
    apiKey: "AIzaSyDhQUkqcJWyLrGafTCnrJTj4N-aq5ifqHo",
    authDomain: "acquire-9b72d.firebaseapp.com",
    databaseURL: "https://acquire-9b72d.firebaseio.com",
    projectId: "acquire-9b72d",
    storageBucket: "acquire-9b72d.appspot.com",
    messagingSenderId: "435322013360",
    appId: "1:435322013360:web:0fd9c4de9e0c9f6f471d75",
    measurementId: "G-4RMQV6H683"
  };
}


// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

// firebase utils
const db = firebase.firestore();
const rtDb = firebase.database();
// const auth = firebase.auth()
// const currentUser = auth.currentUser

export {
  db,
  rtDb,
  rtDbRootNode,
}
